// extracted by mini-css-extract-plugin
export default {"NamespaceInput":"NamespaceInput_NamespaceInput__Eu7ot","AutoCompleteText":"NamespaceInput_AutoCompleteText__IPHZe"};